import {UserOPEEnum} from "../UserOPEEnum";
import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {UserMetricGroupDetailDTO} from "./GetUserMetricGroupCB";

/**
 * I Inner Class
 */
class I {
  id!: number;
}

/**
 * Impersonation-aware counterpart of getUserMetricGroup, which stays self-only. The owner is
 * resolved from the chart itself: a partition/system admin may read one belonging to a user of
 * equal or lower role, within the partitions they are enabled on.
 */
export class GetAllUserMetricGroupCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: UserMetricGroupDetailDTO;

  /**
   * Class constructor
   */
  constructor() {
    super(UserOPEEnum.GetAllUserMetricGroup);
    this.i = new I();
    this.o = new UserMetricGroupDetailDTO();
  }

}
